/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { getTeamColor, getTeamInitials } from '../../~reusables/util/teams';

interface TeamLogoProps {
  teamId: string;
  name: string;
  logoUrl?: string | null;
  size?: number;
}

/** A team's logo, or its initials on a stable colour when it has none. */
export const TeamLogo: React.FC<TeamLogoProps> = ({
  teamId,
  name,
  logoUrl,
  size = 28,
}) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [logoUrl]);

  const radius = Math.round(size / 4);
  const box = {
    flex: 'none',
    width: size,
    height: size,
    borderRadius: radius,
  } as const;

  if (logoUrl && !failed) {
    return (
      <img
        src={logoUrl}
        alt=""
        width={size}
        height={size}
        onError={() => setFailed(true)}
        css={{
          ...box,
          objectFit: 'cover',
          background: 'var(--layout-card-split-bg)',
        }}
      />
    );
  }

  return (
    <span
      aria-hidden
      css={{
        ...box,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: getTeamColor(teamId),
        color: '#fff',
        fontSize: Math.max(9, Math.round(size * 0.38)),
        fontWeight: 700,
        letterSpacing: '0.02em',
      }}
    >
      {getTeamInitials(name)}
    </span>
  );
};
